import { render, staticRenderFns } from "./FiTable.vue?vue&type=template&id=c270f806&scoped=true&lang=pug&"
import script from "./FiTable.vue?vue&type=script&lang=js&"
export * from "./FiTable.vue?vue&type=script&lang=js&"
import style0 from "./FiTable.vue?vue&type=style&index=0&id=c270f806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c270f806",
  null
  
)

export default component.exports